import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cx from "classnames";
import styles from "./styles.module.scss";
const Selector = ({ hed, subHed1, subHed2, selected, image, onClick, variant, disabled = false }) => {
    return (_jsxs("button", { className: cx(styles.selector, styles[variant || "standard"], {
            [styles.selected]: selected,
            [styles.disabled]: disabled,
        }), onClick: onClick, children: [variant === "flavor" && image && (_jsx("img", { src: image, alt: `Image of ${hed}`, height: 78, width: 86, style: { marginBottom: "8px", width: "100%" } })), _jsx("div", { className: styles.hed, children: hed }), subHed1 && _jsx("div", { className: styles.subHed, children: subHed1 }), subHed2 && _jsx("div", { className: styles.subHed, children: subHed2 })] }));
};
export default Selector;
